$(function () {
  const $announcementBar = $('.announcement-bar');
  if ($announcementBar.length > 0 && $announcementBar.children().length > 0) {
    const $firstAnnouncement = $announcementBar.find('.announcement-bar__announcement').first();
    var announcementHeight = parseInt($firstAnnouncement.innerHeight());
    $announcementBar.css('height', announcementHeight + 'px');

    if ($announcementBar.children().length > 1) {
      $firstAnnouncement.clone().attr('data-announcement-index', $announcementBar.children().length).appendTo($announcementBar);
      const $announcements = $announcementBar.find('.announcement-bar__announcement');

      $announcements.each(function () {
        $(this).css('height', announcementHeight + 'px');
      });

      var activeIndex = 0;
      setInterval(() => {
        activeIndex++;
        if (!$announcementBar.find('[data-announcement-index="' + activeIndex + '"]').length > 0) {
          $announcements.each(function () {
            var transition = $(this).css('transition');
            $(this).css('transition', '0s');
            $(this).css('transform', 'translate3d(0, 0, 0)');

            // setTimeout is used to move the callback out of the stack and into the queue.
            // We need to use the queue to ensure that the transition is restored only after
            // the tansition is complete.
            setTimeout(() => {
              $(this).css('transition', transition);
            }, 0);
          });

          activeIndex = 1;
        }

        // setTimeout is used to move the callback out of the stack and into the queue.
        // We need to use the queue to ensure that the movement of the elements comes
        // after the position reset.
        // Value is set: vertical
        setTimeout(() => {
          $announcements.each(function () {
            $(this).css('transform', 'translate3d(0, calc(' + activeIndex + ' * -100%), 0)');
          });
        }, 0);
      }, 5000);
    }
  }
});
